<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13,2C13,2,11.41,2,11.41,2C11.41,2,11.7,1.71,11.7,1.71C11.89,1.53,12,1.28,12,1C12,0.45,11.55,0,11,0C10.72,0,10.47,0.11,10.29,0.29C10.29,0.29,8.29,2.29,8.29,2.29C8.11,2.47,8,2.72,8,3C8,3.28,8.11,3.53,8.29,3.71C8.29,3.71,10.29,5.71,10.29,5.71C10.47,5.89,10.72,6,11,6C11.55,6,12,5.55,12,5C12,4.72,11.89,4.47,11.71,4.29C11.71,4.29,11.41,4,11.41,4C11.41,4,13,4,13,4C13.55,4,14,4.45,14,5C14,5,14,8,14,8C14,8.55,14.45,9,15,9C15.55,9,16,8.55,16,8C16,8,16,5,16,5C16,3.34,14.66,2,13,2C13,2,13,2,13,2ZM7.5,11C7.78,11,8,10.78,8,10.5C8,10.22,7.78,10,7.5,10C7.22,10,7,10.22,7,10.5C7,10.78,7.22,11,7.5,11C7.5,11,7.5,11,7.5,11ZM10,7C10,7,1,7,1,7C0.45,7,0,7.45,0,8C0,8,0,15,0,15C0,15.55,0.45,16,1,16C1,16,10,16,10,16C10.55,16,11,15.55,11,15C11,15,11,8,11,8C11,7.45,10.55,7,10,7C10,7,10,7,10,7ZM9,13.33C9,13.33,7,12,7,12C7,12,6,13,6,13C6,13,4,10,4,10C4,10,2,12.67,2,12.67C2,12.67,2,9,2,9C2,9,9,9,9,9C9,9,9,13.33,9,13.33C9,13.33,9,13.33,9,13.33Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ImageRotateLeft',
} as DefineComponent
</script>
